import Program from "../Component/Program/Program";

const Programs = () => {
    return (
        <div>
            <Program />
        </div>
    )
}

export default Programs;